var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('head-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threeGameView"},[_c('img',{attrs:{"src":require("@/assets/img/20250213204801.png"),"alt":""}}),_c('h1',[_vm._v("联系我们 : mzsxkefu@mzsxgames.com")])])
}]

export { render, staticRenderFns }